define('SageDotCom/Components/Commerce/Cart/MiniCartViewModel',["knockout", 'shoppingCartService', 'eventManager', 'SageDotCom/DataLayer/tealium', 'SageDotCom/DataLayer/Events/bodySelect'], function (ko, shoppingCartService, eventManager, tealium, bodySelectEvent){

    function MiniCartViewModel(cart) {

        Object.defineProperty(this, 'cart', {enumerable: !0, value: ko.observable(cart), configurable: !0, writable: !0});
        Object.defineProperty(this, 'isOpened', {enumerable: !0, value: ko.observable(!1), configurable: !0, writable: !0});
        // wrap into a computed function
        this.isEmpty = ko.computed(this.isEmpty, this);
    }

    MiniCartViewModel.prototype.isEmpty = function isEmpty() {
        return this.cart() === null || this.cart().products === null || this.cart().products.length === 0;
    }

    MiniCartViewModel.prototype.openCart = function openCart(el) {
        this.isOpened(!0);
       
        this.trackCartSelects(el, 'open_cart');

    }

    MiniCartViewModel.prototype.closeCart = function closeCart(el) {
        this.isOpened(!1);
        this.trackCartSelects(el, 'close_cart');

    }

    MiniCartViewModel.prototype.trackCartSelects=function trackCartSelects(el, label){
        var eventObj = bodySelectEvent.GenerateEventMetadata(el, label);
        tealium.event(eventObj);
    }

    MiniCartViewModel.prototype.removeProduct = function removeProduct(excludedProduct, event) {
        if(event.type !== 'click' && (event.type !== 'keyup' || event.keyCode !== 13)) {
            return;
        }

        this.cart().products = this.cart().products.filter(function (product) {
            eventManager.trigger("Sage:RemoveProductEvent", product);
            return product.productSku !== excludedProduct.productSku && product.parentSku !== excludedProduct.parentSku;
        });
        shoppingCartService.calculateCart(this.cart());
    }

    MiniCartViewModel.prototype.checkout = function checkout(){
        shoppingCartService.checkout(jQuery('[data-ux-module="SageDotCom/Components/ProductsCollectionComponent"]').data("ccf_module").personaId, this.cart())
    }

    return MiniCartViewModel;
});
